import React from "react";
import IconButton from '@material-ui/core/IconButton';
import { useStyles } from "./styles";
import Tooltip from '@material-ui/core/Tooltip';

const ButtonBaseIcon = (props) =>{
    const classes = useStyles();
    const {children, onClick=()=>{}, title=""  } = props;
    return (
    <Tooltip title={title}>
        <IconButton aria-label={title} onClick={onClick} className={classes.margin}>
            {children}
        </IconButton>
    </Tooltip>
    )
}
export default ButtonBaseIcon;
